import { Link } from 'react-router-dom';
import ThemeToggle from '@/theme/ThemeToggle';
import { initials } from '../format';

export default function TopBar({
  credits,
  name,
  onAddCredits,
  onSignOut,
  impersonating,
  onStopImpersonating,
  isAdmin,
}: {
  credits: number;
  name: string;
  onAddCredits: () => void;
  onSignOut: () => void;
  impersonating?: boolean;
  onStopImpersonating?: () => void;
  isAdmin?: boolean;
}) {
  return (
    <header className="sticky top-0 z-40 bg-bg border-b border-border">
      {impersonating && (
        <div className="h-9 px-4 md:px-6 flex items-center justify-between gap-3 bg-accent/15 border-b border-accentLine text-sm">
          <span className="text-textp truncate">
            Viewing as {name}. Changes apply to this account.
          </span>
          <button
            onClick={onStopImpersonating}
            className="whitespace-nowrap text-xs font-medium text-accent-text bg-accent hover:bg-accent-hover px-2.5 py-1 rounded-full"
          >
            Stop impersonating
          </button>
        </div>
      )}
      <div className="h-16 px-4 md:px-6 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="w-7 h-7 rounded-md bg-accentSoft border border-accentLine flex items-center justify-center">
            <i className="ri-stack-line text-accent text-base" />
          </span>
          <span className="text-textp font-semibold tracking-tight whitespace-nowrap">Sourcetape</span>
        </Link>

        <div className="flex items-center gap-3">
          {isAdmin && (
            <Link
              to="/admin"
              data-testid="superadmin-link"
              className="whitespace-nowrap flex items-center gap-1.5 text-sm text-texts hover:text-textp px-2 py-1.5"
            >
              <i className="ri-shield-user-line" /> Superadmin
            </Link>
          )}
          <div className="hidden sm:flex items-center gap-2 bg-surface border border-border rounded-full pl-3 pr-1.5 py-1.5">
            <i className="ri-flashlight-line text-accent text-sm" />
            <span className="text-sm text-textp font-mono">{credits}</span>
            <span className="text-xs text-texts">credits</span>
            <button
              onClick={onAddCredits}
              className="whitespace-nowrap text-xs font-medium text-accent hover:text-accent-hover bg-accentSoft px-2.5 py-1 rounded-full transition-colors"
            >
              Add
            </button>
          </div>

          <ThemeToggle className="px-2.5 py-1.5 rounded-md" />
          <button
            onClick={onSignOut}
            title="Sign out"
            className="w-9 h-9 rounded-full bg-accent text-accent-text flex items-center justify-center font-medium text-sm"
          >
            {initials(name)}
          </button>
        </div>
      </div>
    </header>
  );
}
